var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGraph(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.8596 18.9206C35.8593 22.0937 34.9667 25.2028 33.2836 27.8927C31.6005 30.5826 29.1948 32.745 26.3413 34.1328C23.4877 35.5206 20.3014 36.078 17.1463 35.7412C13.9911 35.4043 10.9942 34.187 8.49797 32.2281M2.09343 20.4475C1.78024 17.0029 2.53048 13.5452 4.24305 10.5401C5.95563 7.53509 8.54822 5.12725 11.6714 3.64111C14.7947 2.15496 18.2984 1.66194 21.7105 2.22848C25.1225 2.79502 28.2789 4.3939 30.7543 6.80963M30.9055 30.8822L44.0002 44.003M44.0002 12.4022V3.40296H35.0271",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2 31.4034L17.5307 15.8783C17.8629 15.5483 18.3122 15.3631 18.7804 15.3631C19.2487 15.3631 19.6979 15.5483 20.0302 15.8783L24.596 20.446C24.9275 20.7774 25.3771 20.9635 25.8458 20.9635C26.3145 20.9635 26.764 20.7774 27.0955 20.446L44.0001 3.40332",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGraph);
export default __webpack_public_path__ + "static/media/graph.8c0ec2591a70f79908f9613fee10bc47.svg";
export { ForwardRef as ReactComponent };